const compatModules = {};import * as Mod1 from "./connectors/topic-link/d-tooltips.gjs";
compatModules["connectors/topic-link/d-tooltips"] = Mod1;

export * as connectors$topic__link$d__tooltips$$__module from "./connectors/topic-link/d-tooltips.gjs";
export {
default as connectors$topic__link$d__tooltips$$default
} from "./connectors/topic-link/d-tooltips.gjs";
export default compatModules;
